export default __webpack_public_path__ + "static/media/home-travel-agency-tour-intrest-img03.5037a0dc.jpg";